document.addEventListener('DOMContentLoaded', function () {
  class PkInstalmentsSimulation extends HTMLElement {
    constructor() {
      super();
      
      this.selectionItems = this.querySelectorAll('[data-times-info]');
      this.currentTimesInfoElements = this.querySelectorAll('[data-times-current-info]');
      this.remainingTimesInfoElements = this.querySelectorAll('[data-remaining-time-info]');
      this.priceElements = this.querySelectorAll('[data-current-price]');

      if (this.priceElements.length > 0) {
        this.originalPrice = parseFloat(this.priceElements[0].dataset.currentPrice) / 100;
      }

      this.selectionItems.forEach(item => {
        item.addEventListener('click', () => {
          this.updateTimesInfo(item);
        });
      });
    }

    updateTimesInfo(selectedItem) {
      const value = parseInt(selectedItem.dataset.timesInfo, 10);
      const remainingValue = value - 1;

      this.currentTimesInfoElements.forEach(element => {
        element.textContent = value;
      });

      this.remainingTimesInfoElements.forEach(element => {
        element.textContent = remainingValue;
      });

      this.updateSelectionStyle(selectedItem);
      this.updateInstalmentPrices(value);
    }

    updateSelectionStyle(activeItem) {
      this.selectionItems.forEach(item => {
        item.classList.remove('pk-instalments-simulation__selection-item--active');
      });

      activeItem.classList.add('pk-instalments-simulation__selection-item--active');
    }

    // For customer needs -> always round down to the nearest whole number
    updateInstalmentPrices(instalments) {
      if (this.priceElements.length > 0 && instalments > 0) {
        const instalmentPrice = Math.floor(this.originalPrice / instalments);
    
        this.priceElements.forEach(element => {
          element.textContent = `${this.formatPrice(instalmentPrice)} €`;
        });
      }
    }

    formatPrice(value) {
      return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }
  }

  customElements.define('pk-instalments-simulation', PkInstalmentsSimulation);
});
